import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from '@services/language.service';
import { LoggingService } from '@services/logging.service';
import { MessagesComponent } from '@shared/components/messages/messages.component';

@Component({
    selector: 'app-root',
    template: `
        <main>
            <router-outlet></router-outlet>
            <epx-messages></epx-messages>
        </main>
    `,
    imports: [RouterOutlet, MessagesComponent]
})
export class AppComponent {
    private langService = inject(LanguageService);
    private logging = inject(LoggingService);

    constructor() {
        this.langService.init();
        this.logging.disableLogging();
    }
}
